<template>
  <div class="activity-card" @click="$emit('handleClick', active)">
    <Idle v-if="!active" :datetime="datetime" :title="title" :type="type" :compact="compact" />
    <Finished v-else-if="type === 'finish'" :title="title" :type="type" :datetime="datetime" />
    <Active v-else :title="title" :type="type" :show-add-button="showAddButton" :custom-label="customActiveLabel"
      :timer="timer" :is-loading="isLoading" :date="datetime" />
  </div>
</template>

<script>
import Active from "./Active.vue";
import Idle from "./Idle.vue";
import Finished from "./Finished.vue";

export default {
  components: {
    Active,
    Idle,
    Finished,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    datetime: {
      type: String,
      default: null,
    },
    timer: {
      type: Object,
      default: () => ({
        hour: null,
        minute: null,
        second: null,
      }),
    },
    customActiveLabel: {
      type: String,
      default: null,
    },
    showAddButton: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    colors: {
      setup: "#78909c",
      stop: "#ef5350",
      start: "#ffa726",
      finish: "#66bb6a",
    },
  }),
};
</script>

<style lang="scss">
.activity-card {
  cursor: pointer;

  display: flex;
  flex: 1;
  min-height: 230px;
  height: 100%;

  border: 1px solid #cfc4be;
  border-radius: 24px;

  * {
    user-select: none;
  }
}

@media (max-width: 480px) {
  .activity-card {
    min-height: 180px;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .activity-card {
    min-height: 0;
    border-radius: 18px;
  }
}
</style>
